import Axios from "axios";

import {
  SET_PRICE_INQUIRY_LIST,
  UNSET_PRICE_INQUIRY_LIST,
} from "@/store/mutation-types";

import {
  getPriceInquiries,
  saveUpdatePriceInquiry,
  getPriceInquiryById,
} from "@/store/api";

// initial state
const state = {
  priceInquiryList: [],
  editingPriceInquiry: null,
  viewingPriceInquiry: null,
};

// getters
const getters = {
  getPriceInquiryList(state) {
    return state.priceInquiryList;
  },

  getEditingPriceInquiry: (state) => state.editingPriceInquiry,

  getViewingPriceInquiry: (state) => state.viewingPriceInquiry,
};

// mutations
const mutations = {
  [SET_PRICE_INQUIRY_LIST](state, data) {
    state.priceInquiryList = data;
  },

  [UNSET_PRICE_INQUIRY_LIST](state) {
    state.priceInquiryList = [];
  },

  setEditingPriceInquiry(state, data) {
    state.editingPriceInquiry = data;
  },

  setViewingPriceInquiry(state, data) {
    state.viewingPriceInquiry = data;
  },
};

// actions
const actions = {
  /**
   * Save / Update
   */
  saveUpdatePriceInquiry({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.post(saveUpdatePriceInquiry, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  /**
   * Get List
   */
  getPriceInquiries({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getPriceInquiries, data)
        .then((response) => {

          commit(
            SET_PRICE_INQUIRY_LIST,
            response.data.data
          );

          resolve(response);

        })
        .catch((error) => {

          commit(UNSET_PRICE_INQUIRY_LIST);

          reject(error);

        });
    });
  },

  /**
   * Get By ID
   */
  getPriceInquiryById({ commit }, id) {

    const url = `${getPriceInquiryById}/${id}`;

    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {

      Axios.get(url)
        .then((response) => {

          resolve(response.data);

        })
        .catch((error) => {

          reject(error);

        })
        .finally(() => {

          commit("UNSET_LOADING");

        });
    });
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};